import type { CreateEmployeeDto, EmployeeDetail } from '@ip/shared-types';
import type { EmployeeFormValues } from './EmployeeForm';
import { t } from '@/i18n';

/** The backend overrides a conflicting dateOfBirth with the PESEL-derived one and
 *  reports it instead of doing it silently — surface that to the user. */
export function peselWarningMessage(employee: EmployeeDetail): string | null {
  const warning = employee.peselWarning;
  if (!warning) return null;
  return t('employees.identity.peselOverrodeDateOfBirth', {
    derived: warning.derivedDateOfBirth,
    submitted: warning.submittedDateOfBirth,
  });
}

/** Maps form values to a CreateEmployeeDto. UpdateEmployeeDto is Partial<CreateEmployeeDto>,
 *  so the same DTO works for both create and update endpoints — null fields signal "clear",
 *  undefined fields signal "leave unchanged" (matching backend service-layer semantics). */
export function formValuesToEmployeeDto(values: EmployeeFormValues): CreateEmployeeDto {
  return {
    firstName: values.firstName,
    lastName: values.lastName,
    employmentType: values.employmentType,
    pesel: values.pesel || undefined,
    // Both derived from the PESEL when one is set (the backend re-derives and wins).
    dateOfBirth: values.dateOfBirth || undefined,
    sex: values.sex || undefined,
    idDocumentType: values.idDocumentType || undefined,
    idDocumentNumber: values.idDocumentNumber || undefined,
    taxOffice: values.taxOffice || undefined,
    nfzBranch: values.nfzBranch || undefined,
    privateEmail: values.privateEmail || undefined,
    privatePhone: values.privatePhone || undefined,
    street: values.street || undefined,
    postalCode: values.postalCode || undefined,
    city: values.city || undefined,
    country: values.country || undefined,
    privateIban: values.privateIban || undefined,
    contractStartDate: values.contractStartDate || undefined,
    contractExpiryDate: values.contractExpiryDate || undefined,
    notes: values.notes || undefined,
    contractorId: values.contractor?.contractorId,
    contractorNip: values.contractor?.contractorNip,
  };
}
